import { ShoppedServiceChannel } from "@redotech/redo-fulfillment-rate-common/shopped-services";
import TiktokIcon from "@redotech/redo-icons/tiktok-color-icon.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { assertNever } from "@redotech/util/type";
import { memo } from "react";

/** Marks a rate bought through a marketplace, so it isn't mistaken for the same service rated directly. */
export const RateChannelBadge = memo(function RateChannelBadge({
  channel,
}: {
  channel: ShoppedServiceChannel;
}) {
  switch (channel) {
    case ShoppedServiceChannel.TikTok:
      return (
        <RedoBadge
          segmentLeading={{ type: "icon", Icon: TiktokIcon }}
          size="xs"
          text="TikTok"
        />
      );
    case ShoppedServiceChannel.AmazonBuyShipping:
      return <RedoBadge size="xs" text="Amazon Buy Shipping" />;
    default:
      return assertNever(channel);
  }
});
